import { createAsyncThunk } from '@reduxjs/toolkit'
import type { RootState } from '~publish/legacy/store'
import callRpc from '~publish/legacy/utils/call-rpc'

export const deleteDrafts = createAsyncThunk<
  {
    success: boolean
    message: string
  },
  { profileId: string },
  { state: RootState }
>('generalSettings/deleteDrafts', async ({ profileId }) => {
  const response = await callRpc('deleteDrafts', {
    profileId,
  })

  if (!response.success) {
    throw new Error(response.message)
  }

  return response
})
